import environmntConfig from "../../constants/envconstants"
const apiConfig = {   
  
  setEnvironmentURLs(urlParam) {
      //Add other default hosts as objects inside api_ROOT in future here eg: DAC API, etc.,
      let api_ROOT = {};
      api_ROOT.tpstsvc = environmntConfig.backendURL;
      api_ROOT.authorityOIDC = environmntConfig.authorityOIDC;
      api_ROOT.metadataOIDC = environmntConfig.metadataOIDC;
      api_ROOT.redirectURI = environmntConfig.redirectURI;
      api_ROOT.clientID = environmntConfig.clientID;
      api_ROOT.apiKey= environmntConfig.apiKey;
      api_ROOT.plannedMaintenance = environmntConfig.plannedMaintenance;
      return api_ROOT;
        
  }
};

export default apiConfig;